import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';

const Button = styled.div`
  margin-right: 22px;
  cursor: pointer;
`;

const ClearButton = ({ clearActivityGroupSelection }) => (
  <Button onClick={clearActivityGroupSelection}>
    <i className="material-icons">cancel</i>
  </Button>
);

ClearButton.propTypes = {
  clearActivityGroupSelection: PropTypes.func.isRequired
};

export default ClearButton;



// WEBPACK FOOTER //
// ./src/components/ActivityGroupFilter/ClearButton.jsx